<template>
  <div v-if="debug" class="mb-12 space-y-3 bg-red-100 p-1 border">
    props: <b>{{ props }}</b>
    <br />
    current resolution: <b>{{ currentWidth }}x{{ currentHeight }}</b>
    <br />
    breakpoint valid <b>{{ breakPointValid }}</b>
    <br />
    width valid: <b>{{ widthValid }}</b>
    <br />
    height valid: <b>{{ heightValid }}</b>
  </div>

  <slot v-bind="{ currentWidth, currentHeight, widthValid, heightValid, breakPointValid }" />
</template>

<script setup>
import { computed } from 'vue'
import { useWindowSize, breakpointsTailwind, useBreakpoints } from '@vueuse/core'

// eslint-disable-next-line no-undef
const props = defineProps({
  // greater or smaller rule
  rule: {
    type: String,
    default: 'smaller' // "smaller", "greater"
  },
  // all bp in tailwind.config.js
  breakpoint: {
    type: String,
    default: 'md'
  },
  // width in pixels
  width: {
    type: Number,
    default: 600
  },
  // height in pixels
  height: {
    type: Number,
    default: 500
  },
  debug: {
    type: Boolean,
    default: false
  }
})

// current resolution
const { width: currentWidth, height: currentHeight } = useWindowSize()

// all our breakpoints from TW
const breakpoints = useBreakpoints(breakpointsTailwind)

// will be valid when current breakpoint will meet the rule and then props.breakpoint
const breakPointValid = breakpoints[props.rule](props.breakpoint)

const widthValid = computed(() => {
  if (props.rule === 'smaller') {
    return currentWidth.value < props.width
  } else {
    return currentWidth.value > props.width
  }
})

const heightValid = computed(() => {
  if (props.rule === 'smaller') {
    return currentHeight.value < props.height
  } else {
    return currentHeight.value > props.height
  }
})
</script>
